import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Login Requested': props<{ email: string; password: string }>(),
    'Login Succeeded': props<{ uid: string }>(),
    'Login Failed': props<{ error: string }>(),

    'Logout Requested': emptyProps(),
    'Logout Succeeded': emptyProps(),
    'Logout Failed': props<{ error: string }>(),
  },
});
